import dayjs from 'dayjs';
import React from 'react';
import type { DestinationPublicStepSchema } from 'typings/destinations/DestinationPublicStepSchema';
import styles from './DestinationPublicStepCard.module.css';

type DestinationPublicStepCardProps = Readonly<{
    step: DestinationPublicStepSchema;
}>;

export function DestinationPublicStepCard({
    step,
}: DestinationPublicStepCardProps) {
    return (
        <a
            className={styles.card}
            href={step.public_trip_url}
            target="_blank"
            rel="noreferrer"
        >
            {step.thumbnail_url ? (
                <img
                    className={styles.thumbnail}
                    src={step.thumbnail_url}
                    loading="lazy"
                    alt={step.step_title}
                />
            ) : (
                <div className={styles.thumbnailPlaceholder}>No photo</div>
            )}
            <div className={styles.tripTitle}>{step.step_title}</div>
            <div className={styles.userRow}>
                {step.user_avatar_url ? (
                    <img
                        className={styles.avatar}
                        src={step.user_avatar_url}
                        alt={step.user_display_name}
                    />
                ) : (
                    <div className={styles.avatarPlaceholder} />
                )}
                <span className={styles.userInfo}>
                    {step.user_display_name} ·{' '}
                    {dayjs(step.start_time).format('MMM D, YYYY')}
                </span>
            </div>
        </a>
    );
}
